<template>
  <div class="skeleton-subsection">
    <UiSkeleton
      class="skeleton-subsection__tabs"
      class-name="skeleton-subsection__tabs-item"
      :items="8"
      :error="error"
    />

    <UiSkeleton
      class="skeleton-subsection__actions"
      class-name="skeleton-subsection__actions-item"
      :items="2"
      :error="error"
    />
  </div>
</template>

<script>
export default {
  name: 'SkeletonNavSubsect',
  props: {
    error: { type: [Object, Boolean, Error] },
  },
}
</script>

<style lang="scss" scoped>
.skeleton-subsection {
  display: flex;
  align-items: center;
  width: 100%;

  &__tabs {
    display: flex;
    align-items: center;
    overflow: hidden;
    padding: var(--spaces-s);
    gap: var(--spaces-xs);
    border-radius: var(--radius-xl);
    background: var(--general-bg-navi-inverse);
    backdrop-filter: blur(16px);

    @include media(tablet) {
      gap: var(--spaces-m);
    }
  }

  ::v-deep &__tabs-item {
    flex-shrink: 0;
    width: 110px;
    height: 32px;
    border-radius: 16px;

    @include media(tablet) {
      width: 146px;
      height: 44px;
      border-radius: 22px;
    }
  }

  &__actions {
    display: flex;
    align-items: center;
  }

  ::v-deep &__actions-item {
    &:first-child {
      width: 1px;
      height: 32px;
      margin-left: var(--spaces-xs);
      margin-right: var(--spaces-l);
    }

    &:last-child {
      width: 32px;
      height: 32px;
      border-radius: 50%;
    }

    @include media(tablet) {
      &:first-child {
        height: 44px;
        margin-left: var(--spaces-s);
      }

      &:last-child {
        width: 125px;
        height: 44px;
        border-radius: 22px;
      }
    }
  }
}

</style>
